import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '亚洲一区',
    url: 'https://jianfenxiansheng.cn',
    description: '亚洲一区是您探索亚洲优质内容的首选平台，汇聚独家精选资源，覆盖多元文化、娱乐、资讯与生活方式。',
    email: 'contact@yazhouyiqu.com',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@yazhouyiqu.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <section className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="mb-6">
                <Breadcrumb
                  items={[
                    { label: '首页', href: '/' },
                    { label: '关于我们' },
                  ]}
                />
              </div>
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                关于亚洲一区
              </h1>
              <p className="text-foreground-500 text-base leading-relaxed max-w-2xl">
                您的亚洲优质内容探索伙伴，致力于呈现亚洲文化的多元面貌
              </p>
            </div>
          </section>

          <section className="w-full py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-16">
                <div>
                  <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
                    品牌故事
                  </h2>
                  <div className="flex flex-col gap-3 text-foreground-600 text-sm leading-relaxed">
                    <p>
                      亚洲一区诞生于对亚洲文化的深刻热爱与敬意。在这个信息爆炸的时代，我们注意到真正有深度、有温度的亚洲内容往往被淹没在海量信息之中。于是，一群来自亚洲各地的文化爱好者、媒体人和内容创作者聚在一起，决定打造一个专注于亚洲优质内容的精选平台。
                    </p>
                    <p>
                      我们的使命是成为连接亚洲与世界的内容桥梁——通过精心策划和原创内容，让每一位用户都能在亚洲一区发现亚洲的多元魅力。从日本茶道的禅意静谧，到韩国K-Pop的全球热潮；从越南河粉的市井烟火，到柬埔寨吴哥窟的千年辉煌——我们用心记录亚洲的每一个精彩瞬间。
                    </p>
                    <p>
                      作为一个独立运营的内容平台，我们坚持编辑独立性，每一篇文章都经过严格的选题、调研、撰写和审核流程。我们不追求点击率的最大化，而是追求内容品质和阅读体验的最优化。
                    </p>
                  </div>
                </div>
                <div className="w-full h-[350px] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20Asian%20cultural%20decorations%2C%20warm%20lighting%2C%20team%20collaborating%20around%20wooden%20table%2C%20bookshelves%20with%20Asian%20art%20books%2C%20minimalist%20design%2C%20plants%2C%20calm%20and%20inspiring%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=about-brand-story-01&orientation=landscape"
                    alt="亚洲一区品牌故事"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  我们的声誉
                </h2>
                <p className="text-foreground-500 text-sm">用户和行业对亚洲一区的认可</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                  <div className="text-3xl font-heading font-bold text-primary-500 mb-2">1000+</div>
                  <p className="text-sm text-foreground-600">精选原创文章</p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                  <div className="text-3xl font-heading font-bold text-accent-500 mb-2">50万+</div>
                  <p className="text-sm text-foreground-600">月活跃读者</p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                  <div className="text-3xl font-heading font-bold text-secondary-500 mb-2">6大</div>
                  <p className="text-sm text-foreground-600">内容分类覆盖</p>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  联系我们
                </h2>
                <p className="text-foreground-500 text-sm">欢迎随时与我们取得联系</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div className="flex flex-col gap-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-500">contact@yazhouyiqu.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-700 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">工作时间</h3>
                      <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">办公地址</h3>
                      <p className="text-sm text-foreground-500">亚洲区总部 · 线上办公</p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <h3 className="font-heading text-base font-semibold text-foreground-800 mb-4">给我们留言</h3>
                  <form
                    className="flex flex-col gap-4"
                    method="POST"
                    action="https://readdy.ai/api/form/d9u03p5ca23r0tr1anr0"
                    data-readdy-form
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const form = e.currentTarget;
                      const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement);
                      if (honeypot && honeypot.value.trim() !== '') {
                        alert('感谢您的留言，我们会在1-2个工作日内回复！');
                        form.reset();
                        return;
                      }
                      const formData = new FormData(form);
                      formData.delete('website_alt');
                      try {
                        const res = await fetch(form.action, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: new URLSearchParams(formData as any).toString(),
                        });
                        if (res.ok) {
                          alert('感谢您的留言，我们会在1-2个工作日内回复！');
                          form.reset();
                        } else {
                          alert('提交失败，请稍后重试。');
                        }
                      } catch {
                        alert('网络错误，请稍后重试。');
                      }
                    }}
                  >
                    <input
                      type="text"
                      name="name"
                      placeholder="您的姓名"
                      className="w-full px-4 py-3 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      className="w-full px-4 py-3 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      required
                    />
                    <textarea
                      name="message"
                      placeholder="请输入留言内容（最多500字）"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-3 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      required
                    ></textarea>
                    <div className="field-website_alt_wrap">
                      <input
                        type="text"
                        name="website_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                    </div>
                    <button
                      type="submit"
                      className="w-full px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送留言
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}